import { useCollectionIndexContext } from "../providers";
import { useAppContext } from "../../../AppProvider";
import { useTypes } from "../../../utilities/types";
import {
  faArrowDownShortWide,
  faArrowUpShortWide,
  faPlus,
} from "../../../utilities/fontawesomeIcons";
import { getAllCarriersFromCarrierConfigurations } from "../../../Components/Selects/AsyncSelect/api";
import { FetchParam } from "../../../Models/FetchParam";
import { getCarrierConfigurationOptionStyle } from "../../../Components/Selects/AsyncSelect/styles";
import { CarrierConfiguration } from "../../../Models/CarrierConfiguration";
import { isCollectionsCancellable } from "./index.ts";
import moment from "moment";

export const useListProps = () => {
  const { setModalConfig } = useCollectionIndexContext();

  const { dictionary } = useAppContext();
  const { collectionStatusList } = useTypes();

  return {
    path: `/shipment-service/collections`,
    banner: { enabled: true },
    pagination: { enabled: true },
    title: dictionary.collections.collections,
    create: {
      enabled: true,
      action: () =>
        setModalConfig({
          isOpen: true,
          action: "create",
          size: "md",
          title: dictionary.actions.add,
        }),
      title: dictionary.actions.add,
      icon: faPlus,
    },
    defaultDate: {
      enabled: true,
      fieldName: "date",
      label: dictionary.dates.collection_date,
      value: [
        moment().subtract(1, "months").startOf("day").toDate(),
        moment().endOf("day").toDate(),
      ],
    },
    omnisearch: {
      enabled: true,
      placeholder: dictionary.references.references,
    },
    sorting: [
      {
        orderBy: "desc",
        column: "date",
        icon: faArrowDownShortWide,
        label: dictionary.dates.collection_date,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "date",
        icon: faArrowUpShortWide,
        label: dictionary.dates.collection_date,
        isDefault: false,
      },
    ],
    selectRowsEnabled: { enabled: true },
    filters: {
      name: "collections",
      preserve: true,
      list: [
        {
          fieldName: "status",
          label: dictionary.words.status,
          type: "select",
          isMulti: true,
          options: collectionStatusList,
          primary: true,
          col: 3,
        },
        {
          fieldName: "carrierCode",
          searchKey: "carrierCode",
          label: dictionary.registries.carriers,
          type: "async-select",
          isMulti: true,
          loadOptions: (searchValue: any) => {
            const params: FetchParam = {
              inputValue: searchValue,
              pagination: { page: 0, size: 100 },
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCarriersFromCarrierConfigurations(params);
          },
          optionStyle: (option: CarrierConfiguration) => {
            const CarrierConfigurationOption =
              getCarrierConfigurationOptionStyle(option);
            return <CarrierConfigurationOption />;
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "addressBook.location.label",
          label: dictionary.registries.pickup,
          type: "text",
          placeholder: "Via Roma 1",
          primary: true,
          col: 3,
        },
        {
          fieldName: "addressBook.contactName",
          label: `${dictionary.registries.name} ${dictionary.words.and}
            ${dictionary.users.surname}`,
          type: "text",
          placeholder: "Via Roma 1",
          primary: true,
          col: 3,
          preciseSearch: false,
        },
      ],
    },

    massiveActions: [
      {
        label: dictionary.actions.delete_selected,
        className: "button-1 button-1-danger",
        onClick: (selectedRows: { id: string }[]) =>
          setModalConfig({
            isOpen: true,
            size: "sm",
            action: "delete",
            title: dictionary.actions.delete_selected,
            data: selectedRows.map((row) => row.id),
          }),
        isDisabled: isCollectionsCancellable,
      },
    ],
  };
};
